/**
 * ListItem Node Extension
 * 列表项节点
 */

import { NodeExtension } from '../../core/Extension';
import type { NodeSpec } from '../../core/types';

export class ListItem extends NodeExtension {
  get name() {
    return 'listItem';
  }

  get schema(): NodeSpec {
    return {
      content: 'paragraph block*',
      defining: true,
      parseDOM: [{ tag: 'li' }],
      toDOM() {
        return ['li', { class: 'editor-list-item' }, 0];
      },
    };
  }
}

export default ListItem;
